export default __webpack_public_path__ + "static/testing-128298984afe98ad757c75fb77005e73.png";